var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#D04A02;}\r\n\t.st2{fill:#7D7D7D;}\r\n\t.st3{fill:#2D2D2D;}\r\n\t.st4{fill:#464646;}\r\n\t.st5{fill:#E0301E;}\r\n\t.st6{fill:#DB536A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.3,33.8c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.6,0,6.4l4.8,4.8H45.6v9h25.2L66,58.8c-1.8,1.8-1.8,4.6,0,6.4 c1.8,1.8,4.6,1.8,6.4,0L88,49.5L72.3,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,63v13.5H25v-54h27V36h1.1l7.9-7.9V18c0-2.5-2-4.5-4.5-4.5h-36c-2.5,0-4.5,2-4.5,4.5v63c0,2.5,2,4.5,4.5,4.5h36 c2.5,0,4.5-2,4.5-4.5V70.9L53.1,63H52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2716423f2c860cfbf7f68ca78a3676e2.svg";
export { ForwardRef as ReactComponent };